import { TagIcon } from './TagIcon';

/**
 * author: Google
 * id 0BE85AB2-0D51-411C-B119-789E9E317216
 * name tag
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag.svg
 * tags
 */
export const LocalOfferIcon = TagIcon;
export default LocalOfferIcon